/**
 * Dzwięki użyte w aplikacji - klikniecia na guziki, dobra, zła odpowiedź
 */
const sounds = {
    goodAnswer: require('../assets/sounds/correct.mp3'),
    badAnswer: require('../assets/sounds/wrong.mp3'),
    gotoPark: require('../assets/sounds/synthetic-wood-knock.mp3'),
    gotoLocation: require('../assets/sounds/synthetic-wood-knock.mp3'),
    menuButton: require('../assets/sounds/synthetic-wood-knock.mp3'),
    challengeButton: require('../assets/sounds/synthetic-wood-knock.mp3'),
    nextQuestion: require('../assets/sounds/synthetic-wood-knock.mp3'),
    takePhoto: require('../assets/sounds/snapshot.mp3'),
    recordSound: require('../assets/sounds/star_twinkle_ding.mp3')
}
export default sounds;